<template>
	<div class="no-data-wrap">
		<article class="weui-article">
			<h1>{{msg}}</h1>
		</article>
	</div>
</template>

<script>
    export default {
        name: "noData",
		props: {
            msg: String
		},
    }
</script>

<style scoped lang="stylus">
	.no-data-wrap{
		padding-top 25%
		display flex
		justify-content center
		align-items center
		.weui-article{
			color $no-data-font-color
			h1{
				font-size $no-data-font-size
			}
		}
	}
</style>
